<template>
  <b-card>
    <app-timeline>
      <app-timeline-item
          v-for="notification in allNotifications"
          :key="notification.key"
          :title="notification.titulo"
          :subtitle="notification.descricao"
          time="few minutes ago"
          :icon="resolveIconNotification(notification.type)"
          :variant="resolveVarianteNotification(notification.type)"
      >
        <template #default>

          <p class="media-heading d-flex justify-content-between">
            <b-link
                class="text-secondary"
                :to="notification.link"
                :target="notification.target ? '_blank' : '_self'"
            >
            <span class="font-weight-bolder">
              {{ notification.titulo }}
            </span>
            </b-link>
            <span style="font-size: 0.8rem">{{ getTimeElapsedString(notification.date)}}</span>
          </p>

          <div class="mt-0 pt-0">
            <small class="notification-text mt-0">{{ notification.descricao }}</small>
          </div>
        </template>
      </app-timeline-item>
    </app-timeline>
  </b-card>
</template>

<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
  },
  computed: {
    userData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    allNotifications() {
      return this.$store.getters['storeNotifications/getAllNotifications']
    },
  },
  methods: {
    getTimeElapsedString(timestamp) {
      const currentTime = new Date().getTime();
      const timeElapsed = currentTime - timestamp;
      const seconds = Math.floor(timeElapsed / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      if (days > 0) {
        return `${days} ${days === 1 ? 'dia' : 'dias'} atrás`;
      } else if (hours > 0) {
        return `${hours} ${hours === 1 ? 'hora' : 'horas'} atrás`;
      } else if (minutes > 0) {
        return `${minutes} ${minutes === 1 ? 'minuto' : 'minutos'} atrás`;
      } else {
        return `${seconds} ${seconds === 1 ? 'segundo' : 'segundos'} atrás`;
      }
    },
    resolveIconNotification(type) {
      switch (type) {
        case 'primary':
          return 'BellIcon'
        case 'success':
          return 'CheckCircleIcon'
        case 'danger':
          return 'XCircleIcon'
        case 'warning':
          return 'AlertTriangleIcon'
        case 'info':
          return 'InfoIcon'
        default:
          return 'BellIcon'
      }
    },
    resolveVarianteNotification(type) {
      switch (type) {
        case 'primary':
          return 'primary'
        case 'success':
          return 'success'
        case 'danger':
          return 'danger'
        case 'warning':
          return 'warning'
        case 'info':
          return 'info'
        default:
          return 'primary'
      }
    },
  },
}
</script>
